import React from "react";
import { useHistory } from "react-router-dom";
import ContainerAuthenticated from "containers/Authenticated";

import {
    PageWrapper,
    BackButton,
    PageHeader,
    PageTitle,
    PageSubtitle,
    CharactersGrid,
    CharacterCard,
    CharacterImage,
    CharacterName,
    CharacterRole,
    CharacterCTA
} from "./styled";

// Lista de personagens do Modo Praticar Idiomas (ChatBox01-04)
const characters = [
    {
        name: 'Salomão',
        role: 'Rei sábio',
        image: '/images/salomao_pixel.png',
        path: '/dashboard/chatbox'
    },
    {
        name: 'Daniel',
        role: 'Profeta visionário',
        image: '/images/daniel_pixel.png',
        path: '/dashboard/chatbox02'
    },
    {
        name: 'Ester',
        role: 'Rainha corajosa',
        image: '/images/ester_pixel.png',
        path: '/dashboard/chatbox03'
    },
    {
        name: 'Davi',
        role: 'Rei guerreiro',
        image: '/images/davi_pixel.png',
        path: '/dashboard/chatbox04'
    }
];

export default function DashboardLearning() {
    const history = useHistory();

    const goToCharacter = (path) => history.push(path);
    const goBack = () => history.push('/dashboard');

    return (
        <ContainerAuthenticated primary page={'learning'}>
            <PageWrapper>
                <BackButton onClick={goBack} aria-label="Voltar para escolha de modo">
                    ← Voltar
                </BackButton>

                <PageHeader>
                    <PageTitle>📚 Modo Praticar Idiomas</PageTitle>
                    <PageSubtitle>
                        Escolha um personagem e pratique conversação no idioma que você está estudando. Ele responde no idioma alvo e corrige em português.
                    </PageSubtitle>
                </PageHeader>

                <CharactersGrid>
                    {characters.map((char) => (
                        <CharacterCard key={char.name} onClick={() => goToCharacter(char.path)}>
                            <CharacterImage
                                src={char.image}
                                alt={`${char.name} — ${char.role}`}
                                width="180"
                                height="180"
                            />
                            <CharacterName>{char.name}</CharacterName>
                            <CharacterRole>{char.role}</CharacterRole>
                            <CharacterCTA>Praticar com {char.name.split(' ')[0]} →</CharacterCTA>
                        </CharacterCard>
                    ))}
                </CharactersGrid>
            </PageWrapper>
        </ContainerAuthenticated>
    );
}
